// @flow
import * as React from 'react';
import type {
  FileComponents,
  Toggles,
  Reader,
} from 'docs/data/integration-builder';

const getFilename = (file: React.Element<any>): string => {
  return file.props.children.props.children.props.filename || '';
};

type FileConditions = $Shape<{
  toggles: Toggles,
  reader: ?Reader,
}>;

const isVisible = (
  file: React.Element<any>,
  fileConditions: FileConditions,
): boolean => {
  const when = file.props.children.props.children.props.when;
  const {toggles, reader} = fileConditions;
  if (when && when.toggle) {
    return toggles[when.toggle];
  }

  if (reader && when && when.reader) {
    return reader === when.reader;
  }

  return true;
};

export const loadFiles = (
  paths: Array<string>,
  fileConditions: FileConditions,
  children: Array<React.Element<any>>,
): FileComponents => {
  const components = {};
  children.forEach((child) => {
    if (
      paths.some((p) => child?.props?.file?.includes(`files/${p}`)) &&
      isVisible(child, fileConditions)
    ) {
      const filename = getFilename(child);
      components[filename] = child;
    }
  });
  return components;
};
